/* The rules and the risk configuration of a workspace, which the form of "Test this change" is made from */
export const FETCH_WORKSPACE_CONFIG = 'FETCH_WORKSPACE_CONFIG';
export const FETCH_WORKSPACE_CONFIG_SUCCESS = 'FETCH_WORKSPACE_CONFIG_SUCCESS';
export const FETCH_WORKSPACE_CONFIG_FAIL = 'FETCH_WORKSPACE_CONFIG_FAIL';

export const START_COMPARISON = 'START_COMPARISON';
export const START_COMPARISON_SUCCESS = 'START_COMPARISON_SUCCESS';
export const START_COMPARISON_FAIL = 'START_COMPARISON_FAIL';

/* Following the two runs of a comparison until both are over, and then reading the comparison */
export const FOLLOW_COMPARISON = 'FOLLOW_COMPARISON';
export const STOP_FOLLOWING_COMPARISON = 'STOP_FOLLOWING_COMPARISON';
export const FETCH_COMPARISON_RUNS_SUCCESS = 'FETCH_COMPARISON_RUNS_SUCCESS';
/* A read of the runs failed and is tried again; and the reads that kept failing, which are given up (see followComparisonSaga) */
export const FETCH_COMPARISON_RUNS_RETRY = 'FETCH_COMPARISON_RUNS_RETRY';
export const FETCH_COMPARISON_RUNS_GAVE_UP = 'FETCH_COMPARISON_RUNS_GAVE_UP';
export const FETCH_COMPARISON = 'FETCH_COMPARISON';
export const FETCH_COMPARISON_SUCCESS = 'FETCH_COMPARISON_SUCCESS';
export const FETCH_COMPARISON_FAIL = 'FETCH_COMPARISON_FAIL';
